import { useState, useRef, useCallback } from 'react';
import { useUnmount } from '@betgames/bg-tools';
import classNames from 'classnames';
import classes from 'styles/components/Ripple.module.scss';

interface IRipple {
    className: string;
    start(): void;
}

export const useRipple = (): IRipple => {
    const [className, setClassName] = useState<string>(classes.ripple);
    const timeoutRef = useRef<number>();

    const start = useCallback(() => {
        setClassName(classNames(classes.ripple, classes.animate));

        clearTimeout(timeoutRef.current);

        timeoutRef.current = setTimeout(() => {
            setClassName(classes.ripple);
        }, Number(classes.duration));
    }, []);

    useUnmount(() => {
        clearTimeout(timeoutRef.current);
    });

    return {
        className,
        start,
    };
};
